/**
 *  @class
 *  @function FacetsToggle
 */
class FacetsToggle {
  constructor() {
    this.container = document.getElementById('Facet-Drawer');
    const button = document.getElementById('Facets-Toggle');

    // Add functionality to buttons
    if (button) {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        document.body.classList.toggle('open-cc');
        this.container.classList.toggle('active');
        this.container.removeAttribute('inert');
      });
    }
  }
}

/**
 *  @class
 *  @function SidebarToggle
 */
class SidebarToggle {
  constructor() {
    this.container = document.getElementById('Sidebar-Container');
    const button = document.getElementById('Sidebar-Toggle');

    // Add functionality to buttons
    if (button) {
      const span = button.querySelector('span');

      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.container.classList.toggle('facets--sidebar-open');

        span.textContent = this.container.classList.contains('facets--sidebar-open') ? theme.strings.hideFilters : theme.strings.showFilters;
      });
    }
  }
}

/**
 *  @class
 *  @function MobileFilterToggle
 */
class MobileFilterToggle {
  constructor() {
    this.container = document.getElementById('Facet-Drawer');
    const button = document.getElementById('Mobile-Filter-Toggle');

    // Add functionality to mobile filter button
    if (button) {
      button.addEventListener('click', (e) => {
        console.log('Mobile filter button clicked');
        e.preventDefault();
        document.body.classList.toggle('open-cc');
        this.container.classList.toggle('active');
        this.container.removeAttribute('inert');
      });
    }
  }
}

/**
 *  @class
 *  @function MobileSortToggle
 */
class MobileSortToggle {
  constructor() {
    const button = document.getElementById('Mobile-Sort-Toggle');

    // Add functionality to mobile sort button
    if (button) {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        // Burada sıralama modalını açabilirsiniz
        console.log('Mobile sort button clicked');
      });
    }
  }
}

/**
 *  @class
 *  @function ActiveFilterTags
 */
class ActiveFilterTags {
  constructor() {
    this.initializeActiveFilterTags();
  }

  initializeActiveFilterTags() {
    const activeFilterTags = document.querySelectorAll('.active-filter-tag');
    
    activeFilterTags.forEach(tag => {
      tag.addEventListener('click', (e) => {
        e.preventDefault();
        this.removeFilter(tag);
      });
    });
  }

  checkAndClearActiveFilters() {
    // Tüm aktif filtre tag'larını seç
    const activeFilterTags = document.querySelectorAll('.active-filter-tag');
    console.log('Kalan aktif filtre tag sayısı:', activeFilterTags.length);

    // Eğer hiç aktif filtre tag'ı kalmadıysa
    if (activeFilterTags.length === 0) {
      // Farklı selector'larla active filters bölümlerini bul ve temizle
      const activeFiltersSections = [
        '.active-filters-section', 
        '.active-facets', 
        '#FacetFiltersForm .active-filters-section',
        '#FacetFiltersFormMobile .active-filters-section'
      ];

      activeFiltersSections.forEach(selector => {
        const section = document.querySelector(selector);
        if (section) {
          console.log('Temizlenen bölüm:', selector);
          section.innerHTML = '';
        }
      });
    }
  }

  removeFilter(tag) {
    const filterType = tag.dataset.filterType;
    const filterParam = tag.dataset.filterParam;
    const filterValue = tag.dataset.filterValue;
    const filterLabel = tag.dataset.filterLabel;

    // URL'den parametreyi kaldır
    const url = new URL(window.location);
    
    if (filterType === 'price_range') {
      // Fiyat aralığı için özel işlem
      url.searchParams.delete('filter.v.price.gte');
      url.searchParams.delete('filter.v.price.lte');
        } else {
      // Diğer filtre türleri için
      const currentValues = url.searchParams.getAll(filterParam);
      const newValues = currentValues.filter(value => value !== filterValue);
      
      url.searchParams.delete(filterParam);
      newValues.forEach(value => {
        url.searchParams.append(filterParam, value);
      });
    }

    // Sayfayı yenilemeden güncelle
    FacetFiltersForm.renderPage(url.searchParams.toString(), null, true);

    // Filtre seçeneklerini de güncelle
    this.updateFilterOptions(filterParam, filterValue, filterLabel);

    // Bir sonraki render döngüsünde temizleme işlemini yap
    setTimeout(() => {
      this.checkAndClearActiveFilters();
    }, 100);
  }

  updateFilterOptions(filterParam, filterValue, filterLabel) {
    // Mobil ve masaüstü filtre formlarını bul
    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    const desktopForm = document.getElementById('FacetFiltersForm');

    // Her iki formda da ilgili checkbox'ı bul ve işaretle/işareti kaldır
    const updateCheckbox = (form) => {
      if (!form) return;

      const checkbox = form.querySelector(`input[name="${filterParam}"][value="${filterValue}"]`);
      if (checkbox) {
        checkbox.checked = false;
        // Eğer varsa label'ını da güncelle
        const label = checkbox.closest('label');
        if (label) {
          label.classList.remove('filter-option-label--selected');
        }
      }

      // Kategori göstergesini kaldır
      const categoryItem = form.querySelector(`.filter-category-item[data-category="${filterLabel.toLowerCase().replace(/\s+/g, '-')}"]`);
      if (categoryItem) {
        const indicator = categoryItem.querySelector('.category-indicator');
        if (indicator) {
          indicator.remove();
        }
      }
    };

    updateCheckbox(mobileForm);
    updateCheckbox(desktopForm);
  }
}

/**
 *  @class
 *  @function FacetFiltersForm
 */
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelectorAll('.thb-filter-content--button').forEach((more_button) => {
      more_button.addEventListener('click', this.onMore);
    });
    
    // Input event listener'ını güncelle - fiyat input'larını hariç tut
    const form = this.querySelector('form');
    if (form) {
      form.addEventListener('input', (event) => {
        // Fiyat input'ları için event'i engelle
        if (event.target.classList.contains('price-input-min') || 
            event.target.classList.contains('price-input-max')) {
          return;
        }
        // Diğer input'lar için normal işlem yap
        this.debouncedOnSubmit(event);
      });
    }

    // Add event listener for sort select outside the form
    const sortSelect = this.querySelector('#SortByBar');
    if (sortSelect) {
      sortSelect.addEventListener('change', (event) => {
        this.onSortChange(event);
      });
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  // Yeni reset metodu
  static resetAllFilters(event) {
    // Loading'i göster
    this.showLoading();

    // Tüm filtre formlarını bul
    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    const desktopForm = document.getElementById('FacetFiltersForm');

    // URL'yi sıfırla
    const url = new URL(window.location);
    
    // Tüm filtre parametrelerini kaldır
    const filterParams = [
      'filter.v.price.gte',
      'filter.v.price.lte',
      'filter.v.availability',
      'filter.v.option.color',
      'filter.v.option.size'
    ];

    filterParams.forEach(param => {
      url.searchParams.delete(param);
    });

    // Sıralama parametresini koru
    const sortBy = url.searchParams.get('sort_by');

    // URL'yi temizle
    url.search = '';
    if (sortBy) {
      url.searchParams.set('sort_by', sortBy);
    }

    // Tüm checkbox'ları sıfırla
    const resetCheckboxes = (form) => {
      if (!form) return;

      const checkboxes = form.querySelectorAll('input[type="checkbox"]');
      checkboxes.forEach(checkbox => {
        checkbox.checked = false;
        
        // Label stilini sıfırla
        const label = checkbox.closest('label');
        if (label) {
          label.classList.remove('filter-option-label--selected');
        }
      });

      // Kategori göstergelerini kaldır
      const categoryItems = form.querySelectorAll('.filter-category-item');
      categoryItems.forEach(item => {
        const indicator = item.querySelector('.category-indicator');
        if (indicator) {
          indicator.remove();
        }
      });
    };

    resetCheckboxes(mobileForm);
    resetCheckboxes(desktopForm);

    // Active filter tag'larını temizle
    const activeFilterSections = [
      '.active-filters-section', 
      '.active-facets', 
      '#FacetFiltersForm .active-filters-section',
      '#FacetFiltersFormMobile .active-filters-section'
    ];

    activeFilterSections.forEach(selector => {
      const section = document.querySelector(selector);
      if (section) {
        section.innerHTML = '';
      }
    });

    // Sayfayı yenilemeden güncelle
    FacetFiltersForm.renderPage(url.searchParams.toString(), event, true);
  }

  // Loading fonksiyonları
  static showLoading() {
    const overlay = document.getElementById('FiltersLoadingOverlay');
    if (overlay) {
      overlay.classList.add('active');
    }
  }

  static hideLoading() {
    const overlay = document.getElementById('FiltersLoadingOverlay');
    if (overlay) {
      overlay.classList.remove('active');
    }
  }

  // Varolan renderPage metodunu güncelle
  static renderPage(searchParams, event, updateURLHash = true) {
    console.log('renderPage called with:', searchParams);
    console.log('updateURLHash:', updateURLHash);
    
    const sections = FacetFiltersForm.getSections();
    
    // Loading'i göster
    this.showLoading();
    
    // URL'yi güncelle
    if (updateURLHash) {
      console.log('Updating URL hash with:', searchParams);
      FacetFiltersForm.updateURLHash(searchParams);
    }

    // Yükleme durumunu göster
    const loadingElements = document.querySelectorAll('.thb-filter-count, .mobile-filter-count');
    loadingElements.forEach(el => {
      el.classList.add('loading');
    });

    // Fetch URL'sini oluştur
    const url = `${window.location.pathname}?${searchParams}`;
    console.log('Fetch URL:', url);

    // Bölümleri fetch et ve render et
    FacetFiltersForm.renderSectionFromFetch(url, event);
  }

  // Varolan renderSectionFromFetch metodunu güncelle
  static renderSectionFromFetch(url, event) {
    console.log('Fetch URL:', url);
    
    fetch(url)
      .then(response => {
        console.log('Response status:', response.status);
        return response.text();
      })
      .then((responseText) => {
        console.log('Response text length:', responseText.length);
        const html = responseText;
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
        
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
          html,
          url
        }];
        
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(parsedHTML);
        FacetFiltersForm.renderAdditionalElements(parsedHTML);

        new FacetsToggle();
        new SidebarToggle();
        new MobileFilterToggle();
        new ActiveFilterTags();
        new ActiveFilterButtons();

        // Swiper'ları başlat
        FacetFiltersForm.initializeProductCardSwipers();

        // Loading'i gizle
        this.hideLoading();
        console.log('Fetch completed successfully');
      })
      .catch(error => {
        console.error('Filtre güncelleme hatası:', error);
        // Hata durumunda da loading'i gizle
        this.hideLoading();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    new FacetsToggle();
    new SidebarToggle();
    new MobileFilterToggle();
    new ActiveFilterTags();
    new ActiveFilterButtons();

    // Swiper'ları başlat
    FacetFiltersForm.initializeProductCardSwipers();

    // Loading'i gizle
    this.hideLoading();
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;

    let top = document.getElementById('ProductGridContainer').getBoundingClientRect().top + document.documentElement.scrollTop - parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) - 30;

    document.getElementById('ProductGridContainer').querySelectorAll('.lazyload').forEach((image) => {
      lazySizes.loader.unveil(image);
    });

    // Grid toggle butonlarını yeniden başlat
    this.initializeGridToggles();

    // Ürün kartlarındaki Swiper'ları yeniden başlat
    this.initializeProductCardSwipers();

    window.scrollTo({
      top: top,
      left: 0,
      behavior: "smooth"
    });
  }

  static initializeProductCardSwipers() {
    // Global fonksiyonu çağır
    if (typeof initializeProductCardSwipers === 'function') {
      initializeProductCardSwipers();
    }
  }

  static initializeGridToggles() {
    const gridToggleButtons = document.querySelectorAll('.facets-grid-toggle__button');
    const productsGrid = document.querySelector('.products.collection.row');

    // Local storage'dan kaydedilmiş grid görünümünü al
    const savedGrid = localStorage.getItem('products-grid-view') || '3';

    // Sayfa yüklendiğinde kaydedilmiş görünümü uygula
    if (productsGrid) {
      productsGrid.classList.add(`products-grid--${savedGrid}`);
      const activeButton = document.querySelector(`[data-grid="${savedGrid}"]`);
      if (activeButton) {
        activeButton.classList.add('active');
      }

      // Mevcut medium-up sınıflarını güncelle
      const currentClasses = productsGrid.className.split(' ');
      const newClasses = currentClasses.map(cls => {
        if (cls.startsWith('medium-up-')) {
          return `medium-up-${savedGrid}`;
        }
        return cls;
      });
      productsGrid.className = newClasses.join(' ');

      // CSS custom property'yi güncelle
      productsGrid.style.setProperty('--desktop-columns', savedGrid);
    }

    // Grid toggle butonlarına click event listener ekle
    gridToggleButtons.forEach(button => {
      // Önceki event listener'ları kaldır
      button.removeEventListener('click', button.gridToggleHandler);

      // Yeni event listener ekle
      button.gridToggleHandler = function () {
        const gridType = this.getAttribute('data-grid');
        console.log('Grid toggle clicked:', gridType);

        // Tüm butonlardan active class'ını kaldır
        gridToggleButtons.forEach(btn => btn.classList.remove('active'));

        // Tıklanan butona active class'ını ekle
        this.classList.add('active');

        // Products grid'den eski class'ları kaldır ve yeni grid layout'u uygula
        if (productsGrid) {
          // Eski grid sınıflarını kaldır
          productsGrid.classList.remove('products-grid--3', 'products-grid--4');
          productsGrid.classList.add(`products-grid--${gridType}`);

          // Mevcut medium-up sınıflarını güncelle
          const currentClasses = productsGrid.className.split(' ');
          const newClasses = currentClasses.map(cls => {
            if (cls.startsWith('medium-up-')) {
              return `medium-up-${gridType}`;
            }
            return cls;
          });
          productsGrid.className = newClasses.join(' ');

          // CSS custom property'yi güncelle
          productsGrid.style.setProperty('--desktop-columns', gridType);
          console.log('Updated grid to:', gridType, 'Classes:', productsGrid.className);
        }

        // Local storage'a kaydet
        localStorage.setItem('products-grid-view', gridType);
      };

      button.addEventListener('click', button.gridToggleHandler);
    });
  }

  static renderProductCount(html) {
    // items-found bölümlerini güncellemek için selector'ları tanımla
    const itemsFoundSelectors = [
      '.items-found', 
      '.facet-drawer .items-found', 
      '#FacetFiltersForm .items-found', 
      '#FacetFiltersFormMobile .items-found'
    ];

    // Ürün sayısı bilgisini çıkar
    const productCountElement = html.querySelector('.facets-products-count');
    
    // Her bir selector için güncelleme yap
    itemsFoundSelectors.forEach(selector => {
      const targetElement = document.querySelector(selector);
      const sourceElement = html.querySelector(selector);

      // Eğer hedef ve kaynak element varsa güncelle
      if (targetElement && sourceElement) {
        targetElement.innerHTML = sourceElement.innerHTML;
      } else if (targetElement && productCountElement) {
        // Eğer items-found bulunamazsa, genel ürün sayısı elementini kullan
        targetElement.innerHTML = productCountElement.innerHTML;
      }
    });

    // Ürün sayısı yüklenme durumunu kaldır
    const loadingOverlays = document.querySelectorAll('.thb-filter-count.loading, .mobile-filter-count.loading');
    loadingOverlays.forEach(overlay => {
      overlay.classList.remove('loading');
    });
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    // Mobil ve masaüstü filtre formlarını bul
    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    const desktopForm = document.getElementById('FacetFiltersForm');

    // Her iki formda da filtre seçeneklerini güncelle
    const updateFormFilters = (form) => {
      if (!form) return;

      // Filtre seçeneklerini bul
      const filterOptions = form.querySelectorAll('.filter-options-content');
      
      filterOptions.forEach(option => {
        const category = option.getAttribute('data-category');
        const parsedOption = parsedHTML.querySelector(`.filter-options-content[data-category="${category}"]`);
        
        if (parsedOption) {
          // HTML içeriğini tamamen güncelle
          option.innerHTML = parsedOption.innerHTML;
        }
      });
    };

    updateFormFilters(mobileForm);
    updateFormFilters(desktopForm);

    // Filtre seçeneklerini güncelle
    this.updateFilterSelections(parsedHTML);

    // Active filter tag'larını kontrol et ve gerekirse temizle
    const activeFilterTags = parsedHTML.querySelectorAll('.active-filter-tag');
    const activeFilterSections = [
      '.active-filters-section', 
      '.active-facets', 
      '#FacetFiltersForm .active-filters-section',
      '#FacetFiltersFormMobile .active-filters-section'
    ];

    if (activeFilterTags.length === 0) {
      activeFilterSections.forEach(selector => {
        const section = document.querySelector(selector);
        if (section) {
          section.innerHTML = '';
        }
      });
    }

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    new FacetsToggle();
    new SidebarToggle();
  }

  static updateFilterSelections(parsedHTML) {
    // Mobil ve masaüstü filtre formlarını bul
    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    const desktopForm = document.getElementById('FacetFiltersForm');

    // Her iki formda da filtre seçimlerini güncelle
    const updateFormSelections = (form) => {
      if (!form) return;

      // Tüm checkbox'ları sıfırla
      const checkboxes = form.querySelectorAll('input[type="checkbox"]');
      checkboxes.forEach(checkbox => {
        checkbox.checked = false;
        const label = checkbox.closest('label');
        if (label) {
          label.classList.remove('filter-option-label--selected');
        }
      });

      // Kategori göstergelerini sıfırla
      const categoryItems = form.querySelectorAll('.filter-category-item');
      categoryItems.forEach(item => {
        const indicator = item.querySelector('.category-indicator');
        if (indicator) {
          indicator.remove();
        }
      });

      // Aktif filtreleri bul ve işaretle
      const activeFilters = parsedHTML.querySelectorAll('.active-filter-tag');
      activeFilters.forEach(activeFilter => {
        const filterParam = activeFilter.dataset.filterParam;
        const filterValue = activeFilter.dataset.filterValue;
        const filterLabel = activeFilter.dataset.filterLabel;

        // Checkbox'ı bul ve işaretle
        const checkbox = form.querySelector(`input[name="${filterParam}"][value="${filterValue}"]`);
        if (checkbox) {
          checkbox.checked = true;
          const label = checkbox.closest('label');
          if (label) {
            label.classList.add('filter-option-label--selected');
          }
        }

        // Kategori göstergesini ekle
        const categoryItem = form.querySelector(`.filter-category-item[data-category="${filterLabel.toLowerCase().replace(/\s+/g, '-')}"]`);
        if (categoryItem && !categoryItem.querySelector('.category-indicator')) {
          const indicator = document.createElement('span');
          indicator.classList.add('category-indicator');
          indicator.textContent = '✓';
          categoryItem.appendChild(indicator);
        }
      });
    };

    updateFormSelections(mobileForm);
    updateFormSelections(desktopForm);
  }

  static updateFilterCounts(parsedHTML) {
    // Mobil ve masaüstü filtre formlarını bul
    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    const desktopForm = document.getElementById('FacetFiltersForm');

    // Her iki formda da filtre seçeneklerinin ürün sayaçlarını güncelle
    const updateFilterCountsInForm = (form) => {
      if (!form) return;

      // Tüm filtre seçeneklerini bul
      const filterOptions = form.querySelectorAll('.thb-filter-content li');
      
      filterOptions.forEach(option => {
        const parsedOption = parsedHTML.querySelector(
          `.thb-filter-content li[data-value="${option.dataset.value}"]`
        );

        if (parsedOption) {
          // Ürün sayacını güncelle
          const countElement = option.querySelector('.count');
          const parsedCountElement = parsedOption.querySelector('.count');
          
          if (countElement && parsedCountElement) {
            countElement.textContent = parsedCountElement.textContent;
          }

          // Devre dışı bırakma durumunu güncelle
          const checkbox = option.querySelector('input[type="checkbox"]');
          const parsedCheckbox = parsedOption.querySelector('input[type="checkbox"]');
          
          if (checkbox && parsedCheckbox) {
            if (parsedCheckbox.disabled) {
              checkbox.disabled = true;
              option.classList.add('filter-option-item--disabled');
            } else {
              checkbox.disabled = false;
              option.classList.remove('filter-option-item--disabled');
            }
          }
        }
      });
    };

    updateFilterCountsInForm(mobileForm);
    updateFilterCountsInForm(desktopForm);
  }

  // Yeni metod: Filtre seçeneklerinin durumlarını dinamik olarak güncelle
  static updateFilterOptionStates(parsedHTML) {
    // Mobil ve masaüstü filtre formlarını bul
    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    const desktopForm = document.getElementById('FacetFiltersForm');

    // Her iki formda da filtre seçeneklerinin durumlarını güncelle
    const updateFilterStatesInForm = (form) => {
      if (!form) return;

      // Tüm checkbox'ları bul
      const checkboxes = form.querySelectorAll('input[type="checkbox"]');
      
      checkboxes.forEach(checkbox => {
        const name = checkbox.name;
        const value = checkbox.value;
        
        // Parsed HTML'de aynı checkbox'ı bul
        const parsedCheckbox = parsedHTML.querySelector(`input[name="${name}"][value="${value}"]`);
        
        if (parsedCheckbox) {
          // Disable durumunu güncelle
          checkbox.disabled = parsedCheckbox.disabled;
          
          // Checked durumunu güncelle
          checkbox.checked = parsedCheckbox.checked;
          
          // Label'ı bul ve güncelle
          const label = checkbox.closest('label');
          const parsedLabel = parsedCheckbox.closest('label');
          
          if (label && parsedLabel) {
            // Disabled class'ını güncelle
            if (parsedLabel.classList.contains('filter-option-label--disabled')) {
              label.classList.add('filter-option-label--disabled');
            } else {
              label.classList.remove('filter-option-label--disabled');
            }
            
            // Selected class'ını güncelle
            if (parsedLabel.classList.contains('filter-option-label--selected')) {
              label.classList.add('filter-option-label--selected');
            } else {
              label.classList.remove('filter-option-label--selected');
            }
          }
          
          // Ürün sayacını güncelle
          const countElement = label?.querySelector('.option-count');
          const parsedCountElement = parsedLabel?.querySelector('.option-count');
          
          if (countElement && parsedCountElement) {
            countElement.textContent = parsedCountElement.textContent;
          }
        }
      });
    };

    updateFilterStatesInForm(mobileForm);
    updateFilterStatesInForm(desktopForm);
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-filters-section', '.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      const targetElement = document.querySelector(selector);

      // Hedef element ve active facets elementi varsa işlem yap
      if (targetElement && activeFacetsElement) {
        // Eğer active filter tag'ları yoksa, ilgili bölümü tamamen temizle
        if (activeFacetsElement.children.length === 0) {
          targetElement.innerHTML = '';
        } else {
          // Varsa normal şekilde güncelle
          targetElement.innerHTML = activeFacetsElement.innerHTML;
        }
      } else if (targetElement) {
        // Eğer hedef element varsa ama active facets elementi yoksa, temizle
        targetElement.innerHTML = '';
      }
    });

    // Hata ayıklama için log ekle
    console.log('Active facets render edildi');

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-filter-count'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
      document.querySelector(selector).classList.remove('loading');
    });

    // Aktif filtre butonlarını güncelle
    const activeFilterButtons = document.querySelector('#ActiveFilterButtons');
    if (activeFilterButtons) {
      const htmlActiveFilterButtons = html.querySelector('#ActiveFilterButtons');
      if (htmlActiveFilterButtons) {
        activeFilterButtons.innerHTML = htmlActiveFilterButtons.innerHTML;
      } else {
        activeFilterButtons.innerHTML = '';
      }
    }

    // Fiyat input'larını güncelle
    const priceContainers = document.querySelectorAll('.price-range-content');
    priceContainers.forEach(container => {
      const minInput = container.querySelector('.price-input-min');
      const maxInput = container.querySelector('.price-input-max');
      
      if (minInput && maxInput) {
        const urlParams = new URLSearchParams(window.location.search);
        
        // Min fiyat değerini güncelle
        const minPrice = urlParams.get(minInput.name);
        if (minPrice) {
          minInput.value = minPrice;
        } else {
          minInput.value = '';
        }
        
        // Max fiyat değerini güncelle
        const maxPrice = urlParams.get(maxInput.name);
        if (maxPrice) {
          maxInput.value = maxPrice;
        } else {
          maxInput.value = '';
        }
        
        // PriceRangeSlider instance'ını bul ve validasyon yap
        const priceSlider = container._priceSliderInstance;
        if (priceSlider && typeof priceSlider.validatePriceRange === 'function') {
          priceSlider.validatePriceRange();
        }
      }
    });
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({
      searchParams
    }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData);
    if (searchParams.get('filter.v.price.gte') === "0.00") {
      searchParams.delete('filter.v.price.gte');
    }
    if (document.querySelector('.price_slider')) {
      if (searchParams.get('filter.v.price.lte') === parseFloat(document.querySelector('.price_slider').dataset.max).toFixed(2)) {
        searchParams.delete('filter.v.price.lte');
      }
    }
    FacetFiltersForm.renderPage(searchParams.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }

  onMore(e) {
    let ul = this.closest('.thb-filter-content').querySelector('ul');

    if (ul.hasAttribute('filters-open')) {
      this.textContent = theme.strings.showMore;
      ul.removeAttribute('filters-open');
    } else {
      this.textContent = theme.strings.showLess;
      ul.setAttribute('filters-open', '');
    }
    e.preventDefault();
  }

  onSortChange(event) {
    const form = this.querySelector('form');
    const formData = new FormData(form);

    // Add the sort value to form data
    formData.set('sort_by', event.target.value);

    // Convert form data to URL search params
    const searchParams = new URLSearchParams(formData);

    // Render the page with new sort parameter
    FacetFiltersForm.renderPage(searchParams.toString(), event);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

/**
 *  @class
 *  @function FacetRemove
 */
class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('a').forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
      });
    });
  }
}

customElements.define('facet-remove', FacetRemove);


/**
 *  @class
 *  @function FacetToolbar
 */
class FacetToolbar extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.productGrid = this.closest('#ProductGridContainer');
    this.layoutSwitcher = this.querySelector('.facets--bar-view-as');
    this.buttons = this.querySelectorAll('.facets--bar-view-as-button');
    this.productLayout = window.localStorage.getItem('product-layout');
    if (this.layoutSwitcher) {
      this.buttons.forEach((button) => {
        button.addEventListener('click', (evt) => {
          [].forEach.call(this.buttons, function (el) {
            el.removeAttribute('disabled');
          });
          this.onLayoutChange(button, button.dataset.value);
          evt.preventDefault();
        });
      });

      if (this.productLayout && this.productLayout === 'list') {
        const toggle = this.querySelector(`.facets--bar-view-as-button-${this.productLayout}`);
        if (toggle) toggle.click();
      }
    }
  }
  onLayoutChange(button, value) {
    button.setAttribute('disabled', '');
    this.productGrid.dataset.layout = value;
    window.localStorage.setItem('product-layout', value);

    // Grid toggle butonlarını güncelle
    const gridToggleButtons = document.querySelectorAll('.facets-grid-toggle__button');
    gridToggleButtons.forEach(btn => btn.classList.remove('active'));

    if (value === 'grid') {
      const savedGrid = localStorage.getItem('products-grid-view') || '3';
      const activeButton = document.querySelector(`[data-grid="${savedGrid}"]`);
      if (activeButton) {
        activeButton.classList.add('active');
      }
    }
  }

}
customElements.define('facet-toolbar', FacetToolbar);

/**
 *  @class
 *  @function PriceSlider
 */
class PriceSlider extends HTMLElement {

  constructor() {
    super();
  }
  connectedCallback() {
    this.slider = this.querySelector('.price_slider');
    this.amounts = this.querySelector('.price_slider_amount');
    this.form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    this.inputEvent = new CustomEvent('input');

    const args = {
      start: [
        parseFloat(this.slider.dataset.minValue || 0),
        parseFloat(this.slider.dataset.maxValue || this.slider.dataset.max)
      ],
      connect: true,
      step: 10,
      direction: document.dir,
      range: {
        'min': 0,
        'max': parseFloat(this.slider.dataset.max)
      }
    };
    noUiSlider.create(this.slider, args);

    this.slider.noUiSlider.on('update', this.onSliderUpdate.bind(this));
    this.slider.noUiSlider.on('change', this.onSliderChange.bind(this));

  }
  onSliderUpdate(values) {
    this.amounts.querySelector('.field__input_min').value = values[0];
    this.amounts.querySelector('.field__input_max').value = values[1];
  }

  onSliderChange(values) {
    this.form.querySelector('form').dispatchEvent(this.inputEvent);
  }
}
customElements.define('price-slider', PriceSlider);

/**
 *  @class
 *  @function MobileFilterButton
 */
class MobileFilterButton {
  constructor() {
    this.filterButton = document.querySelector('#Mobile-Filter-Toggle');
    this.updateFilterCount();
  }

  updateFilterCount() {
    if (!this.filterButton) return;

    const urlParams = new URLSearchParams(window.location.search);
    let activeFilterCount = 0;

    // URL'den vendor parametrelerini kontrol et
    const vendors = urlParams.getAll('vendor');
    activeFilterCount += vendors.length;

    // Diğer filtreleri kontrol et (fiyat aralığı, renk, boyut vb.)
    const filterParams = ['price_min', 'price_max', 'filter.v.option.color', 'filter.v.option.size'];
    filterParams.forEach(param => {
      if (urlParams.get(param)) {
        activeFilterCount++;
      }
    });

    // Filtre sayısını güncelle
    const span = this.filterButton.querySelector('span');
    if (span) {
      const baseText = span.textContent.replace(/ \(\d+\)/, ''); // Mevcut sayıyı temizle
      if (activeFilterCount > 0) {
        span.textContent = baseText + ` (${activeFilterCount})`;
        this.filterButton.classList.add('active');
      } else {
        span.textContent = baseText;
        this.filterButton.classList.remove('active');
      }
    }
  }
}

/**
 * Yeni Mobil Filtreleme Modal Fonksiyonları
 */
class NewMobileFilterModal {
  constructor() {
    this.init();
  }

  init() {
    this.setupCategoryNavigation();
    this.setupShowMoreButtons();
    this.setupPriceRangeButtons();
    this.setupActiveFilters();
  }

  setupCategoryNavigation() {
    const categoryItems = document.querySelectorAll('.filter-category-item');
    const optionContents = document.querySelectorAll('.filter-options-content');

    categoryItems.forEach((item, index) => {
      item.addEventListener('click', () => {
        const category = item.getAttribute('data-category');

        // Tüm kategorileri pasif yap
        categoryItems.forEach(cat => cat.classList.remove('active'));
        optionContents.forEach(content => content.classList.remove('active'));

        // Seçili kategoriyi aktif yap
        item.classList.add('active');

        // İlgili içeriği göster - index'e göre eşleştir
        if (optionContents[index]) {
          optionContents[index].classList.add('active');
        } else {
          // Fallback: data-category ile eşleştir
          const targetContent = document.querySelector(`.filter-options-content[data-category="${category}"]`);
          if (targetContent) {
            targetContent.classList.add('active');
          }
        }
      });
    });

    // İlk kategoriyi varsayılan olarak aktif yap
    if (categoryItems.length > 0) {
      categoryItems[0].click();
    }
  }

  setupShowMoreButtons() {
    const showMoreButtons = document.querySelectorAll('.show-more-button');

    showMoreButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const list = button.closest('.filter-options-content').querySelector('.filter-options-list');
        const hiddenItems = list.querySelectorAll('.filter-option-item[style*="display: none"]');

        if (hiddenItems.length > 0) {
          // İlk 10 gizli öğeyi göster
          const itemsToShow = Array.from(hiddenItems).slice(0, 10);
          itemsToShow.forEach(item => {
            item.style.display = 'block';
          });

          // Eğer daha fazla gizli öğe yoksa butonu gizle
          const remainingHidden = list.querySelectorAll('.filter-option-item[style*="display: none"]');
          if (remainingHidden.length === 0) {
            button.style.display = 'none';
          }
        }
      });
    });
  }

  setupPriceRangeButtons() {
    const applyPriceButtons = document.querySelectorAll('.apply-price-button');

    applyPriceButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const form = button.closest('form');
        if (form) {
          form.submit();
        }
      });
    });
  }

  setupActiveFilters() {
    const buttons = document.querySelectorAll('.active-filter-tag');

    buttons.forEach(button => {
      button.addEventListener('click', (e) => {
       
      });
    });
  
  }
}

/**
 * Mobil Filtreleme Modalını Başlat
 */
function initMobileFilterModal() {
  if (document.getElementById('Facet-Drawer')) {
    new NewMobileFilterModal();
  }
}

document.addEventListener('DOMContentLoaded', initMobileFilterModal);

/**
 * Filtreleme Modalı Açıldığında Kategorileri Yükle
 */
document.addEventListener('facet-drawer-opened', initMobileFilterModal);

// Modal açıldığında da başlat
document.addEventListener('click', (e) => {
  if (e.target && e.target.id === 'Mobile-Filter-Toggle') {
    setTimeout(() => {
      initMobileFilterModal();
    }, 300);
  }
});

// MutationObserver ile modal açıldığını tespit et
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
      const drawer = document.getElementById('Facet-Drawer');
      if (drawer && drawer.classList.contains('active')) {
        setTimeout(() => {
          initMobileFilterModal();
        }, 100);
      }
    }
  });
});

// Observer'ı başlat
document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.getElementById('Facet-Drawer');
  if (drawer) {
    observer.observe(drawer, { attributes: true });
  }
});

/**
 * Fiyat Aralığı Slider Fonksiyonu
 */
class PriceRangeSlider {
  constructor(container) {
    this.container = container;
    this.minInput = container.querySelector('.price-input-min');
    this.maxInput = container.querySelector('.price-input-max');
    this.applyButton = container.querySelector('.apply-price-button');

    // Instance'ı container'a kaydet (renderAdditionalElements için)
    container._priceSliderInstance = this;

    this.init();
    this.loadPriceValuesFromURL();
  }

  loadPriceValuesFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    
    // Min fiyat değerini yükle
    const minPriceParam = this.minInput ? this.minInput.name : 'filter.v.price.gte';
    const minPrice = urlParams.get(minPriceParam);
    if (minPrice && this.minInput) {
      this.minInput.value = minPrice;
    }
    
    // Max fiyat değerini yükle
    const maxPriceParam = this.maxInput ? this.maxInput.name : 'filter.v.price.lte';
    const maxPrice = urlParams.get(maxPriceParam);
    if (maxPrice && this.maxInput) {
      this.maxInput.value = maxPrice;
    }
    
    // Validasyon yap
    this.validatePriceRange();
  }

  init() {
    if (this.minInput && this.maxInput) {
      this.setupInputValidation();
      this.setupApplyButton();
    }
  }

  setupInputValidation() {
    const inputs = [this.minInput, this.maxInput];

    inputs.forEach(input => {
      input.addEventListener('input', (e) => {
        // Sadece sayı girişine izin ver (type="number" olduğu için bu gerekli değil ama güvenlik için)
        e.target.value = e.target.value.replace(/[^0-9]/g, '');
        
        // Sadece validasyon yap, form submit etme
        this.validatePriceRange();
      });
    });
  }

  validatePriceRange() {
    const minValue = parseInt(this.minInput.value) || 0;
    const maxValue = parseInt(this.maxInput.value) || 0;
    
    // Eğer her iki değer de girilmişse kontrol et
    if (this.minInput.value && this.maxInput.value) {
      if (minValue > maxValue) {
        // Hata durumu - input'ları kırmızı yap
        this.minInput.style.borderColor = '#ff4444';
        this.maxInput.style.borderColor = '#ff4444';
        
        // Apply butonunu devre dışı bırak
        if (this.applyButton) {
          this.applyButton.disabled = true;
          this.applyButton.style.opacity = '0.5';
          this.applyButton.style.cursor = 'not-allowed';
        }
        
        // Hata mesajını göster
        this.showErrorMessage('Minimum fiyat, maksimum fiyattan büyük olamaz');
      } else {
        // Geçerli durum - input'ları normale döndür
        this.minInput.style.borderColor = '';
        this.maxInput.style.borderColor = '';
        
        // Apply butonunu aktif et
        if (this.applyButton) {
          this.applyButton.disabled = false;
          this.applyButton.style.opacity = '1';
          this.applyButton.style.cursor = 'pointer';
        }
        
        // Hata mesajını gizle
        this.hideErrorMessage();
      }
    } else {
      // Değerler eksikse input'ları normale döndür
      this.minInput.style.borderColor = '';
      this.maxInput.style.borderColor = '';
      
      // Apply butonunu aktif et
      if (this.applyButton) {
        this.applyButton.disabled = false;
        this.applyButton.style.opacity = '1';
        this.applyButton.style.cursor = 'pointer';
      }
      
      // Hata mesajını gizle
      this.hideErrorMessage();
    }
  }

  showErrorMessage(message) {
    // Mevcut hata mesajını kaldır
    this.hideErrorMessage();
    
    // Yeni hata mesajı oluştur
    const errorDiv = document.createElement('div');
    errorDiv.className = 'price-error-message';
    errorDiv.style.color = '#ff4444';
    errorDiv.style.fontSize = '12px';
    errorDiv.style.marginTop = '5px';
    errorDiv.textContent = message;
    
    // Hata mesajını container'a ekle
    this.container.appendChild(errorDiv);
  }

  hideErrorMessage() {
    const existingError = this.container.querySelector('.price-error-message');
    if (existingError) {
      existingError.remove();
    }
  }

  setupApplyButton() {
    if (this.applyButton) {
      this.applyButton.addEventListener('click', (e) => {
        e.preventDefault(); // Form submit'i engelle
        
        const form = this.container.closest('form');
        if (form) {
          // Fiyat değerlerini kontrol et
          const minValue = parseInt(this.minInput.value) || 0;
          const maxValue = parseInt(this.maxInput.value) || 0;

          if (this.minInput.value && this.maxInput.value && minValue > maxValue) {
            // Hata durumunda işlem yapma
            return;
          }

          // Loading göster
          FacetFiltersForm.showLoading();
          
          // Form data oluştur ve FacetFiltersForm.renderPage() kullan
          const formData = new FormData(form);
          const searchParams = new URLSearchParams(formData);
          
          // Fiyat parametrelerini temizle (sadece geçerli olanları ekle)
          if (this.minInput.value) {
            searchParams.set(this.minInput.name, this.minInput.value);
          } else {
            searchParams.delete(this.minInput.name);
          }
          
          if (this.maxInput.value) {
            searchParams.set(this.maxInput.name, this.maxInput.value);
          } else {
            searchParams.delete(this.maxInput.name);
          }
          
          // Sayfa yenileme yerine FacetFiltersForm.renderPage() kullan
          FacetFiltersForm.renderPage(searchParams.toString(), e, true);
          
          // Modal'ı kapat
          setTimeout(() => {
            const clickCapture = document.querySelector('.click-capture');
            if (clickCapture) {
              clickCapture.click();
            }
          }, 100); // Kısa bir gecikme ile modal'ı kapat
        }
      });
    }
  }
}

/**
 * Filtreleme Modalı İçindeki Fiyat Aralıklarını Başlat
 */
document.addEventListener('DOMContentLoaded', () => {
  const priceContainers = document.querySelectorAll('.price-range-content');
  priceContainers.forEach(container => {
    new PriceRangeSlider(container);
  });
});

/**
 *  @class
 *  @function ActiveFilterButtons
 */
class ActiveFilterButtons {
  constructor() {
    this.buttons = document.querySelectorAll('.active-filter-button');
    this.initializeButtons();
  }

  initializeButtons() {
    this.buttons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        
        const filterType = button.getAttribute('data-filter-type');
        const filterParam = button.getAttribute('data-filter-param');
        const filterValue = button.getAttribute('data-filter-value');
        const filterLabel = button.getAttribute('data-filter-label');

        console.log('Active filter button clicked:', filterType, filterParam, filterValue);

        // Loading göster
        FacetFiltersForm.showLoading();

        // URL'yi al
        const url = new URL(window.location);

        // Filtre tipine göre parametreyi kaldır
        if (filterType === 'price_range') {
          // Fiyat filtresi için min ve max değerleri kaldır
          url.searchParams.delete('filter.v.price.gte');
          url.searchParams.delete('filter.v.price.lte');
        } else {
          // Normal filtre için parametreyi kaldır
          url.searchParams.delete(filterParam);
        }

        // Sayfa yenileme yerine FacetFiltersForm.renderPage() kullan
        const searchParams = url.searchParams.toString();
        FacetFiltersForm.renderPage(searchParams, e, true);
      });
    });
  }

  updateActiveFilterButtons() {
    // Mevcut butonları temizle
    const container = document.getElementById('ActiveFilterButtons');
    if (container) {
      container.innerHTML = '';
    }

    // URL'den aktif filtreleri al ve yeni butonlar oluştur
    const urlParams = new URLSearchParams(window.location.search);
    
    // Fiyat filtresi kontrolü
    const minPrice = urlParams.get('filter.v.price.gte');
    const maxPrice = urlParams.get('filter.v.price.lte');
    if (minPrice || maxPrice) {
      const priceButton = document.createElement('button');
      priceButton.className = 'active-filter-button';
      priceButton.setAttribute('data-filter-type', 'price_range');
      priceButton.setAttribute('data-filter-param', 'price');
      priceButton.setAttribute('data-filter-value', 'price_range');
      priceButton.setAttribute('data-filter-label', 'Fiyat');
      
      let priceText = '';
      if (minPrice && maxPrice) {
        priceText = `${minPrice} - ${maxPrice}`;
      } else if (minPrice) {
        priceText = `${minPrice}+`;
      } else if (maxPrice) {
        priceText = `-${maxPrice}`;
      }
      
      priceButton.innerHTML = `
        <span>${priceText}</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M18 6 6 18"/>
          <path d="m6 6 12 12"/>
        </svg>
      `;
      
      if (container) {
        container.appendChild(priceButton);
      }
    }

    // Diğer filtreler için (bu kısım daha karmaşık, şimdilik sadece fiyat filtresi)
    // Diğer filtreler için de benzer mantık uygulanabilir
  }
}

// Grid View Toggle Functionality
document.addEventListener('DOMContentLoaded', function () {
  FacetFiltersForm.initializeGridToggles();
  FacetFiltersForm.initializeSwiperSliders();
  FacetFiltersForm.initializeProductRuntime();

  // Yeni sınıfları başlat
  new MobileFilterButton();
  new MobileFilterToggle();
  new ActiveFilterTags();
  new ActiveFilterButtons(); // Yeni sınıfı başlat
});

// Facets form submit olduğunda grid görünümünü koru
document.addEventListener('submit', function (e) {
  if (e.target.closest('#FacetFiltersForm')) {
    const activeGrid = localStorage.getItem('products-grid-view') || '3';
    const hiddenInput = document.createElement('input');
    hiddenInput.type = 'hidden';
    hiddenInput.name = 'grid_view';
    hiddenInput.value = activeGrid;
    e.target.appendChild(hiddenInput);
  }
});

window.addEventListener('load', () => {
  new FacetsToggle();
  new SidebarToggle();
  new MobileFilterToggle();
  new MobileSortToggle();
  new ActiveFilterTags();
  FacetFiltersForm.initializeSwiperSliders();
  FacetFiltersForm.initializeProductRuntime();
});

// Reset butonları için event listener
document.addEventListener('DOMContentLoaded', () => {
  const resetButtons = document.querySelectorAll('#ResetAllFilters');
  
  resetButtons.forEach(button => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      FacetFiltersForm.resetAllFilters(event);
    });
  });
});